import { Colors } from "Themes/Colors";
import { mobileSize } from "Themes/Metrics";
import styled from "styled-components";

export const AddButton = styled.div`
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    cursor: pointer;
    margin: 5px;
    color: ${Colors.secondaryColor};
    display: flex;
    @media ${mobileSize.large} {
        display: none;
    }
`;

export const Navbar = styled.div`
    height: 100px;
    display: flex;
    align-items: center;
    position: fixed;
    width: 100%;
    top: 0px;
    background-color: ${Colors.mainColor};
    position: relative;
    z-index: 4;
`;

export const HomeContainer = styled.div`
    margin-left: 2.5%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 0px;
`;

export const HomeTitle = styled.div`
    color: white;
    font-family: Titillium Web;
    cursor: pointer;
    letter-spacing: 3px;
    line-height: 10px;
    height: 10px;
    font-size: 25px;
`;

export const AuthButton = styled.button`
    border-radius: 5px;
    border: solid 2px white;
    background-color: transparent;
    color: white;
    padding: 5px 10px;
    margin: 0px 5px;
    &:hover {
        background-color: white;
        color: ${Colors.mainColor};
    }
`;

export const AuthButtonContainer = styled.div`
    padding: 5px;
    display: flex;
    align-items: center;
`;


export const ProfileIcon = styled.div`
    background-color: white;
    padding: 0 5px 0 5px;
    display: none;
    flex-direction: column;
    margin: 5;
    @media ${mobileSize.large} {
        display: flex;
        padding: 20px;
        background-color: transparent;
        color: white
    }
`; 

const styles = {
    navItemContainer: {
        display: "flex",
        justifyContent: "space-between",
    },
    navbar: {
        display: "flex",
        alignItems: "center",
        zIndex: 90
    },
    profileButtons: {
        flex: 2,
        textAlign: "right"
    },
    dataButtons: {
        flex: 1
    },
    searchbar: {
        flex: 1
    },
    dropdown: {
        flex: 1,
        flexGrow: 1,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        marginRight: "5%",
    },
    homeContainer: {
        marginLeft: "1%"
    }
}

export default styles;